module.exports = __webpack_public_path__ + "img/terroir-2.5afc4655.jpg";